export const getPriceStep = (minPrice: number): number => {
  if (minPrice >= 0 && minPrice <= 999) return 100;
  if (minPrice >= 1000 && minPrice <= 9999) return 1000;

  return 10000;
};
